var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card-item',{attrs:{"card":"item_timetable","tabs":_vm.tabs,"activeTab":_vm.activeTab,"id":_vm.id,"isFull":true,"infoKeys":_vm.infoKeys},on:{"setTab":_vm.setTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }